import { Injectable } from '@angular/core';
import { ScreenUtils } from 'src/app/utils/screen.utils';

@Injectable({
  providedIn: 'root'
})
export class FontHelperService {

  public fontSizeLimit = 0;
  public fontSizeOffset = 0;
  public fontSizePadrao = 16;
  private classesEspecificas: { nome: string, fontOriginal: string }[] = []

  constructor() {
    this.definirFontSize();

    this.classesEspecificas = [
      { nome: "topic-atendimento-size", fontOriginal: "0.75rem" },
      { nome: "description-atendimento-size", fontOriginal: "0.75rem" },
      { nome: "title-atendimento-size", fontOriginal: "0.90625rem" },
      { nome: "sigepo-accordeon-title", fontOriginal: "1.125rem" },
      { nome: "content", fontOriginal: "0.75rem"}
    ]
  }

  private definirFontSize() {
    const element = document.body;
    const style = window.getComputedStyle(element);
    const pxFontSize = style.getPropertyValue('font-size');
    const fontSizeAtual = pxFontSize.replace(/\D/g, "");

    this.fontSizeLimit = parseInt(fontSizeAtual) - this.fontSizePadrao;
    this.fontSizeOffset = parseInt(fontSizeAtual) - this.fontSizePadrao;
  }

  public changeSize(sinal: string) {
    switch (sinal) {
      case '+':
        if (this.fontSizeLimit < 3) {
          this.fontSizeLimit += 1;
          this.aumentarFonte();
        }
        break;
      case '-':
        if (this.fontSizeLimit > -1) {
          this.fontSizeLimit -= 1;
          this.reduzirFonte();
        }
        break;
    }
  }

  private aumentarFonte() {
    document.body.style.setProperty(
      'font-size',
      `calc(1rem + ${++this.fontSizeOffset}px)`
    );

    if (ScreenUtils.getScreenResolution() < 1200)
      this.atualizarClassesEspecificas();
  }

  private reduzirFonte() {
    document.body.style.setProperty(
      'font-size',
      `calc(1rem + ${--this.fontSizeOffset}px)`
    );

    if (ScreenUtils.getScreenResolution() < 1200)
      this.atualizarClassesEspecificas();
  }

  private atualizarClassesEspecificas() {
    const elementosDeClasses: { elementos: Element[], fontOriginal: string }[] = [];

    this.classesEspecificas.forEach((c) => {
      const element = Array.from(document.getElementsByClassName(c.nome));
      if (element)
        elementosDeClasses.push({ elementos: element, fontOriginal: c.fontOriginal });
    });

    if (elementosDeClasses.some(x => x))
      elementosDeClasses.forEach(ec => {
        ec.elementos.forEach((e) => {
          (e as HTMLElement).style.setProperty(
            'font-size',
            `calc(${ec.fontOriginal} + ${this.fontSizeOffset}px)`,
            'important'
          );
        })
      })
  }
}
